const pazeSelector = store => store.paze;

export default pazeSelector;
